module.exports = __webpack_public_path__ + "static/media/18.fe77b450.png";